import "./styles.css";
import { parseRoute } from "./router";
import {
  PAGE_TITLES,
  renderContact,
  renderHome,
  renderNotFound,
  renderPrivacy,
  renderTerms,
} from "./site/pages";
import { bootStorybook } from "./storybook/boot";

function requireAppRoot(): HTMLElement {
  const el = document.getElementById("app");
  if (!el) throw new Error("missing_root");
  return el;
}

const appRoot = requireAppRoot();

function paint(html: string): void {
  appRoot.innerHTML = html;
}

function renderStaticPage(): void {
  const route = parseRoute(window.location.pathname);

  switch (route.kind) {
    case "home":
      document.title = PAGE_TITLES.home;
      paint(renderHome());
      break;
    case "privacy":
      document.title = PAGE_TITLES.privacy;
      paint(renderPrivacy());
      break;
    case "terms":
      document.title = PAGE_TITLES.terms;
      paint(renderTerms());
      break;
    case "contact":
      document.title = PAGE_TITLES.contact;
      paint(renderContact());
      break;
    case "not_found":
      document.title = PAGE_TITLES.notFound;
      paint(renderNotFound());
      break;
    case "story":
      void bootStorybook(appRoot, route.token);
      break;
  }
}

renderStaticPage();
